// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1Bgz1","header":"MergedInvoice_header__1t2J1"};